import {
    SELECTION_CONTEXT,
    JOB_REQUEST_STATUS,
    JOB_STATUS,
} from '@ProdWb/JobDetails/constants'

import {
    JobDetailsDocument,
    JobProductionCountry,
    useDownloadQualityDocumentsMutation,
    useUpdateJobProductionCountryMutation,
} from '~/gql/graphql'
import logger from '~/lib/logger'

export const canUpdateJobrequestDueDate = (
    status?: string,
    selectionContext?: string,
) => {
    return (
        status === JOB_REQUEST_STATUS.VIEWED ||
        status === JOB_REQUEST_STATUS.SENT ||
        status === JOB_STATUS.UNACCEPTED ||
        (selectionContext === SELECTION_CONTEXT.JOB_REQUEST &&
            status === JOB_REQUEST_STATUS.ACCEPTED)
    )
}

export const shouldShowEditIcon = (
    isDueDate?: boolean,
    status?: string,
    selectionContext?: string,
) => {
    return (
        isDueDate &&
        (status === JOB_REQUEST_STATUS.VIEWED ||
            status === JOB_REQUEST_STATUS.SENT ||
            status === JOB_STATUS.UNACCEPTED ||
            (selectionContext === SELECTION_CONTEXT.JOB_REQUEST &&
                status === JOB_REQUEST_STATUS.ACCEPTED))
    )
}

export const MutationOperations = () => {
    const [downloanQualityDocuments] = useDownloadQualityDocumentsMutation()
    const [updateJobProductionCountryMutation] =
        useUpdateJobProductionCountryMutation()

    return {
        downloadInspectionDocuments: (jobRequestId: number) => {
            return downloanQualityDocuments({
                variables: {
                    jobRequestId,
                },
            })
        },
        updateJobProductionCountry: (
            jobId: number,
            productionCountry: string,
        ) => {
            return updateJobProductionCountryMutation({
                variables: {
                    jobId,
                    productionCountry:
                        productionCountry as JobProductionCountry,
                },
                refetchQueries: [
                    {
                        query: JobDetailsDocument,
                        variables: {
                            id: jobId,
                        },
                        fetchPolicy: 'network-only',
                    },
                ],
            })
                .then(res => res.data)
                .catch(err => {
                    logger.exception(err, {
                        extra: {
                            info: 'Failed to update the production country',
                            jobId,
                        },
                    })
                })
        },
    }
}
